import { useCreditNoteDetailVM } from 'presentation/hook/CreditNote/useCreditNoteDetailVM';
import { useCreditNoteHeaderMaintenanceTracked } from 'presentation/store/CreditNote/CreditNoteHeaderMaintenanceProvider';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import CreditNoteDetailContent from './CreditNoteDetailContent';
import CreditNoteDetailTitleBar from './CreditNoteDetailTitleBar';
import { CreditNoteHeaderFieldFormPanel } from './Form/CreditNoteHeaderFieldFormPanel';
const CreditNoteDetailMaintenance: React.FC = () => {
    const creditNoteDetailVM = useCreditNoteDetailVM();
    const [creditNoteHeaderState] = useCreditNoteHeaderMaintenanceTracked();
    const [isLoading, setIsLoading] = useState(true);
    const { currentCreditNoteHdr } = creditNoteHeaderState;

    const initialScreen = useCallback(async () => {
        setIsLoading(true);
        try {
            await Promise.allSettled([
                creditNoteDetailVM.onPageInit(currentCreditNoteHdr),
                creditNoteDetailVM.loadDropdownOption(),
            ]);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }, [creditNoteDetailVM, currentCreditNoteHdr]);

    useEffect(() => {
        initialScreen();
    }, [initialScreen])


    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;
    return <>
        <div className="main-comp-wrapper">
            <CreditNoteDetailTitleBar />
            <SliderPanel
                isOpen={true}
                draggable={true}
                leftSectionWidth={"30%"}
                rightSectionWidth={"70%"}
                leftChildren={<CreditNoteHeaderFieldFormPanel />}
                rightChildren={<CreditNoteDetailContent />}
            />
        </div>
    </>
}
export default memo(CreditNoteDetailMaintenance);